import { render } from "./DashboardFitRegistry.vue?vue&type=template&id=2b5e83fb&lang=pug"
import script from "./DashboardFitRegistry.vue?vue&type=script&lang=js"
export * from "./DashboardFitRegistry.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__